import React from "react";
import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";
import { RegisterCode } from "./registerCode";
import { RegisterForm } from "./registerForm";
import "./register.css";
import { RegisterFinish } from "./registerFinish";
import Consent from "../../components/Pdpa/Consent";

const Register = () => {
  const [role, setRole] = React.useState("");
  const [school, setSchool] = React.useState("");
  const [registerNow, setRegisterNow] = React.useState(false);
  const [email, setEmail] = React.useState("");

  const [isConsent, setIsConsent] = React.useState(false);

  if (email) {
    return (
      <Container>
        <Background>
          <RegisterFinish email={email} />
        </Background>
      </Container>
    );
  }

  if (registerNow) {
    return (
      <Container>
        <Background>
          <Title>ลงทะเบียน</Title>
          <RegisterForm school={school} role={role} setEmail={setEmail} />
        </Background>
      </Container>
    );
  } else if (!role) {
    return (
      <>
        {isConsent ? (
          <Container>
            <Background style={{ height: "540px" }}>
              <Title>ลงทะเบียน</Title>
              {!role && <span>เลือกสถานะของคุณ</span>}
              <div
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                  marginTop: "40px",
                  width: "100%",
                }}
              >
                {!role && (
                  <>
                    <UserTypeButton
                      onClick={() => setRole("student")}
                      style={{ background: "#FFA226" }}
                    >
                      สามเณร
                    </UserTypeButton>
                    <UserTypeButton
                      onClick={() => setRole("monk")}
                      style={{ background: "#FC6B4B" }}
                    >
                      พระสงฆ์ พระอาจารย์
                    </UserTypeButton>
                    <UserTypeButton
                      onClick={() => setRole("staff")}
                      style={{ background: "#31A9FF" }}
                    >
                      ครูฆราวาส
                    </UserTypeButton>
                  </>
                )}
              </div>
            </Background>
          </Container>
        ) : (
          <Consent onConsent={() => setIsConsent(true)} />
        )}
      </>
    );
  } else if (role) {
    return (
      <Container>
        <Background>
          <Title>ลงทะเบียน</Title>
          <RegisterCode
            role={role}
            setSchool={setSchool}
            setRegisterNow={setRegisterNow}
          />
        </Background>
      </Container>
    );
  }

  return <div>Register</div>;
};

const Container = styled.div`
  width: 100%;
  background-color: #fffbeb;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Background = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1144px;

  background-color: white;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;

  padding-bottom: 80px;

  span {
    font-family: "Noto Sans Thai";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    // margin-top: 8px;
    text-align: center;

    color: #4b5768;
  }

  ${responsive.tablet(css`
    max-width: 834px;
    padding-bottom: 50px;
  `)}

  ${responsive.mobile(css`
    max-width: 375px;
    padding-bottom: 40px;
  `)}
`;

const Title = styled.div`
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;
  color: #058459;
  margin-top: 40px;
`;

const UserTypeButton = styled.button`
  border-radius: 8px;
  width: 770px;
  height: 100px;
  font-family: "Noto Sans Thai";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  color: white;
  border: 0;
  margin: auto;

  ${responsive.mobile(css`
    max-width: 343px;
    height: 62px;
    font-size: 18px;
    font-weight: 400;
  `)}
`;

export default Register;
